export const StepCard = ({ number, icon: Icon, title, description }) => (
  <div className="flex-1 flex flex-col items-center text-center relative" data-testid={`how-it-works-step-${number}`}>
    <div className="w-16 h-16 rounded-full border-2 border-stranger-orange flex items-center justify-center mb-4 bg-warm-white relative z-10">
      <Icon className="w-7 h-7 text-stranger-orange" strokeWidth={1.75} />
    </div>
    <span className="text-stranger-orange font-extrabold text-sm mb-2">{String(number).padStart(2, "0")}</span>
    <h3 className="font-extrabold uppercase text-sm tracking-wide mb-2">{title}</h3>
    <p className="text-sm text-midnight-black/70 font-medium max-w-[220px]">{description}</p>
  </div>
);
